module.exports = __webpack_public_path__ + "img/wx.b312f7d7.png";